<template>
    <footer class="footer pt-4">
        <b-container>

            
        
            <!-- <b-row class="pt-4">
                <b-col md="10" offset-md="1" lg="8" offset-lg="2">
                    <b-row>
                        <b-col cols="4" class="mb-3 text-center" v-html="column1" />
                        <b-col cols="4" class="mb-3 text-center" v-html="column2" />
                        <b-col cols="4" class="mb-3 text-center" v-html="column3" />
                    </b-row>
                    <div class="text-center mb-3" v-html="column4" />
                </b-col>
            </b-row>
            <br />
             -->
        </b-container>
        <div class="px-4">
            <div class="foldoutToggle">Information</div>
            <div v-html="column1" class="foldout"></div>

            <!-- <div v-b-toggle.accordion-1 class="foldoutToggle">Information <svgicon class="float-right when-closed" icon="plus" width="25" height="25" color="#000"></svgicon><svgicon class="float-right when-opened" icon="minus" width="25" height="25" color="#000"></svgicon></div>
            <b-collapse id="accordion-1" v-html="column1" class="foldout" accordion="footer"></b-collapse>

            <div v-b-toggle.accordion-2 class="foldoutToggle">Blog <svgicon class="float-right when-closed" icon="plus" width="25" height="25" color="#000"></svgicon><svgicon class="float-right when-opened" icon="minus" width="25" height="25" color="#000"></svgicon></div>
            <b-collapse id="accordion-2" v-html="column2" class="foldout" accordion="footer"></b-collapse>

            <div v-b-toggle.accordion-3 class="foldoutToggle">Om Skovgaard Vine <svgicon class="float-right when-closed" icon="plus" width="25" height="25" color="#000"></svgicon><svgicon class="float-right when-opened" icon="minus" width="25" height="25" color="#000"></svgicon></div>
            <b-collapse id="accordion-3" v-html="column3" class="foldout" accordion="footer"></b-collapse> -->

            <div class="text-center mt-3 mb-3" v-html="column4" />
        </div>

        <div>
                <div class="text-center bottom">
                    <span>Skovgaard Vine ApS</span>
                    <span>Agenavej 39 - 2670 Greve</span>
                    <span>+45 70 22 66 19</span><br class="d-xl-none" />
                    <!-- <span>Alle priser er i DKK inkl. moms</span>
                    <span>Følgende betalingskort kan benyttes:</span>
                    <img src="/Dist/img/footer-betalingskort.png" /> -->
                </div>
            </div>
    </footer>
</template>

<script>
import "../../icons/_rk/facebook";
import "../../icons/_rk/instagram";
import "../../icons/_rk/video";
import "../../icons/plus";
import "../../icons/minus";
export default {
    computed:{
        column1(){
            return window["siteData"]["FooterColumn1"];
        },
        column2(){
            return window["siteData"]["FooterColumn2"];
        },
        column3(){
            return window["siteData"]["FooterColumn3"];
        },
        column4(){
            return window["siteData"]["FooterColumn4"];
        },
    }
};
</script>
<style lang="scss" scoped>
    .foldoutToggle{
        // text-transform: uppercase;
        font-size:16px;
        padding:6px 8px;
        border-bottom:solid 2px black;
        
    }
    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
    display: none;
    }
    .foldout{
        padding:10px 8px 5px 8px;
        /deep/ h3{
            display: none;
        }
        /deep/ div{
            padding:2px 0;
        }
    }
</style>

<style lang="scss">
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins";
@import "../colors";

    .facebook:hover path,
    .video:hover path,
    .instagram:hover path{
        fill:$rkBrown;
        cursor: pointer;
    }
    .video path[pid='4'],
    .instagram path[pid='1']{
        fill:#EAE8E5 !important; 
    }
    .footer{
        color: white !important;
        background-color: $dark;
        line-height:20px;
        display: block;
        padding-bottom:0.25rem;
        // /deep/ a{
        //     // color:$white;
        // }
        a{
            color:$white;
        }
        h3{
            font-size: 0.96rem;
            font-weight: bold;
            margin-bottom:0;
        }
    }
    .bottom{
        font-size:12px;
        span, img{
            display:inline-block;
            margin:2px 12px;
        }
    }
    
</style>
